import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// eslint-disable-next-line import/no-extraneous-dependencies
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
// import fr from 'vuetify/es5/locale/fr';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#da004b',
        secondary: '#1c7ed6',
        accent: '#1c7ed6',
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg',
  },
});
